import type { JSX } from '@builder.io/qwik';
import { useContext } from '@builder.io/qwik';
import { component$, Slot, useContextProvider, $ } from '@builder.io/qwik';
import { AnalyticsContext } from '~/contexts/AnalyticsContext';
import { sendAnalyticsEvent } from '~/utilities/Analytics';
import { AppDataContext } from '~/contexts/AppDataContext';
import type { AnalyticsType } from '~/types/AnalyticsType';

export default component$((): JSX.Element => {
  const appData = useContext(AppDataContext);

  useContextProvider(AnalyticsContext, {
    event: {
      GA_event_action: 'page component viewable impression',
    },
    actions: {
      sendEvent: $((event: AnalyticsType['event']) =>
        sendAnalyticsEvent(event, appData.payloadToSSR)
      ),
    },
  });

  return <Slot />;
});
